import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { setTaxbill } from '../../modules/taxbillModule/taxbill';
import TaxBillColAndPayForm from '../../components/taxbillmng/TaxBillColAndPayForm';
import * as taxbillApi from '../../lib/api/taxbill';
import { useSelector } from 'react-redux';


const TaxBillColAndPayFormContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const { taxbill, user } = useSelector(({ taxbillModule, auth }) => ({
    taxbill: taxbillModule.taxbill.taxbill,
    user: auth.user,
  }));

  useEffect(() => {
    if (taxbill) {
      let step = getActiveStep(taxbill);
      setActiveStep(step);
    }
  }, [taxbill, activeStep, dispatch]);

  const getActiveStep = (taxbill) => {
    let step = 0;
    if (taxbill.reqPlanYn === 'Y' && taxbill.reqCompYn === 'N') {
      //발행완료여부 체크
      step = 1;
    } else if (taxbill.reqCompYn === 'Y' && taxbill.procPlanYn === 'N') {
      //지급(수금) 요청 체크
      step = 2;
    } else if (taxbill.procPlanYn === 'Y' && taxbill.procCompYn === 'N') {
      //수금(지급)요청 여부

      step = 3;
    } else if (taxbill.procCompYn === 'Y' && taxbill.rsltCompYn === 'N') {
      //수금(지급) 완료 여부

      step = 4;
    } else if (taxbill.rsltCompYn === 'Y') {//실적확정
      step = 5;
    }
    return step;
  };

  const initialValues = {
    procTyp: taxbill && taxbill.procTyp !== null ? taxbill.procTyp : '',
    procPlanDt:
      taxbill && taxbill.procPlanDt !== null ? taxbill.procPlanDt : '',
    procPlanYn:
      taxbill && taxbill.procPlanYn !== null && taxbill.procPlanYn === 'Y'
        ? true
        : false,

    procCompDt:
      taxbill && taxbill.procCompDt !== null ? taxbill.procCompDt : '',
    procCompYn:
      taxbill && taxbill.procCompYn !== null && taxbill.procCompYn === 'Y'
        ? true
        : false,
  };

  const validationSchema = yup.object({
    procTyp: yup.string().required('지급유형을 선택하세요'),
    procPlanDt: yup.date().nullable(),
    procCompDt: yup.date().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {

    let dataToSubmit = {
      invUuid: taxbill.invUuid,
      procTyp: values.procTyp,
      procPlanDt: values.procPlanDt
        ? dayjs(values.procPlanDt).format('YYYY-MM-DD')
        : '',
      procPlanYn: values.procPlanYn ? 'Y' : 'N',
      procCompDt: values.procCompDt
        ? dayjs(values.procCompDt).format('YYYY-MM-DD')
        : '',
      procCompYn: values.procCompYn ? 'Y' : 'N',
    };

    //차후 보충 필요
    if (activeStep === 2) {
      dataToSubmit.procPlanUsr = user.usrUuid;
    } else if (activeStep === 3) {
      dataToSubmit.procCompUsr = user.usrUuid;
    }

    try {
      const res = await taxbillApi.editTaxbill(dataToSubmit);
      //console.log(res.data.info);
      if (res.data) {
        dispatch(setTaxbill(res.data.info));
        enqueueSnackbar('수금&지급 정보 저장 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return <TaxBillColAndPayForm formik={formik} activeStep={activeStep} />;
};

export default TaxBillColAndPayFormContainer;
